module.exports = __webpack_public_path__ + "static/media/superhero.ce071b15.svg";